import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        content: null,
        loadingStatus: 'notLoading'
    },
    mutations: {
        SET_LOADING_STATUS(state, status){
            state.loadingStatus = status
        },
        SET_CONTENT(state, content) {
            state.content = content
        }
    },
    actions: {
        fetchContent(context){
            context.commit('SET_LOADING_STATUS', 'loading')
            return axios.get( process.env.VUE_APP_API+'wp-json/ssw/v1/content')
            .then((response) => {
                context.commit('SET_CONTENT', response.data)
                context.commit('SET_LOADING_STATUS', 'notLoading')
            })
        }
    },
    getters: {
        getFlexibleContent: (state) => (slug) => {
            if(state.content != null){
                return state.content.pages.find(page => page.slug === slug).flexible_content
            }
        },
        /* OPTIONS */
        getOptions: (state) => {
            if(state.content != null){
                return state.content.options
            }
        },
        getOption: (state) => (option) => {
            if(state.content != null){
                return state.content.options[option]
            }
        },
        getOptionsHomePage: (state) => {
            if(state.content != null){
                return state.content.options.posts_page
            }
        },
        getOptionsPostsPage: (state) => {
            if(state.content != null){
                return state.content.options.posts_page
            }
        },
        getOptionsLogo: (state) => {
            if(state.content != null){
                return state.content.options.logo
            }
        },
        getOptionsFavicon: (state) => {
            if(state.content != null){
                return state.content.options.favicon
            }
        },
        getOptionsSingleFooterBlockPl: (state) => {
            if(state.content != null){
                return state.content.options.single_footer_block_pl
            }
        },
        getOptionsSingleFooterBlockEn: (state) => {
            if(state.content != null){
                return state.content.options.single_footer_block_en
            }
        },
        getOptionsWebsiteName: (state) => {
            if(state.content != null){
                return state.content.options.website_name
            }
        },
        getSeoTitleTemplate: (state) => {
            if(state.content != null){
                return state.content.options.seo_title_template
            }
        },
        /* POSTS */
        getPosts: (state) => (lang) => {
            if(state.content != null){
                return state.content.posts.filter(posts => posts.lang === lang)
            }
        },
        getPost: (state) => (slug) => {
            if(state.content != null){
                return state.content.posts.find(post => post.slug === slug)
            }
        },
        getPostSeoTitle: (state) => (slug) => {
            if(state.content != null){
                return state.content.posts.find(post => post.slug === slug).seo_title
            }
        },
        getPostSeoTitleTemplate: (state) => (slug) => {
            if(state.content != null){
                return state.content.posts.find(post => post.slug === slug).seo_title_template
            }
        },
        getPostTitle: (state) => (slug) => {
            if(state.content != null){
                return state.content.posts.find(post => post.slug === slug).title
            }
        },
        /* PAGES */
        getPages: (state) => {
            if(state.content != null){
                return state.content.pages
            }
        },
        getPage: (state) => (slug) => {
            if(state.content != null){
                return state.content.pages.find(page => page.slug === slug)
            }
        },
        getPageSeoTitle: (state) => (slug) => {
            if(state.content != null){
                return state.content.pages.find(page => page.slug === slug).seo_title
            }
        },
        getPageSeoTitleTemplate: (state) => (slug) => {
            if(state.content != null){
                return state.content.pages.find(page => page.slug === slug).seo_title_template
            }
        },
        getPageTitle: (state) => (slug) => {
            if(state.content != null){
                return state.content.pages.find(page => page.slug === slug).title
            }
        },
        /* BLOCKS */
        getBlock: (state) => (id) => {
            if(state.content != null){
                return state.content.blocks[id].flexible_content
            }
        },
    }
})
